import { type MetaFunction } from '@remix-run/react'
import { brandName } from '#app/components/branding.js'
import { type loader as charactersLoader } from './characters.tsx'

export default function CharactersIndexRoute() {
	return (
		<p className="text-sm text-muted-foreground">Select a character to view details.</p>
	)
}

export const meta: MetaFunction<
	null,
	{ 'routes/users+/$username_+/characters': typeof charactersLoader }
> = ({ params, matches }) => {
	const match = matches.find((m) => m.id === 'routes/users+/$username_+/characters')
	const displayName = match?.data?.owner.name ?? params.username
	const count = match?.data?.owner.characters.length ?? 0
	return [
		{ title: `${displayName}'s Characters | ${brandName}` },
		{ name: 'description', content: `${displayName}'s ${count} character${count !== 1 ? 's' : ''} on ${brandName}` },
	]
}
